/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type BillingSettingsContainer_invoiceSettings$ref = any;
export type BillingSettingsContainerQueryVariables = {||};
export type BillingSettingsContainerQueryResponse = {|
  +invoiceSettings: {|
    +$fragmentRefs: BillingSettingsContainer_invoiceSettings$ref
  |}
|};
export type BillingSettingsContainerQuery = {|
  variables: BillingSettingsContainerQueryVariables,
  response: BillingSettingsContainerQueryResponse,
|};
*/


/*
query BillingSettingsContainerQuery {
  invoiceSettings {
    ...BillingSettingsContainer_invoiceSettings
    id
  }
}

fragment BillingSettingsContainer_invoiceSettings on InvoiceSettings {
  id
  wiringInstructions
  contactPerson
  contactPhoneNumber
  contactEmail
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "BillingSettingsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceSettings",
        "kind": "LinkedField",
        "name": "invoiceSettings",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BillingSettingsContainer_invoiceSettings"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "BillingSettingsContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceSettings",
        "kind": "LinkedField",
        "name": "invoiceSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wiringInstructions",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPerson",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "contactEmail",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "BillingSettingsContainerQuery",
    "operationKind": "query",
    "text": "query BillingSettingsContainerQuery {\n  invoiceSettings {\n    ...BillingSettingsContainer_invoiceSettings\n    id\n  }\n}\n\nfragment BillingSettingsContainer_invoiceSettings on InvoiceSettings {\n  id\n  wiringInstructions\n  contactPerson\n  contactPhoneNumber\n  contactEmail\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '8d30454e42944b85bf2423aba42d698b';

module.exports = node;
